import React from 'react';
import {
  Collapse, Navbar, Badge, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink
} from 'reactstrap';
import { Link } from 'react-router-dom'
import Icon from './styles/icon';
import { connect } from 'react-redux'
import { SetLoggedIn } from './redux/actions'
import store from './redux/store'
import classNames from 'classnames'


export default class Header extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      selected: 1
    };

    this.logout = this.logout.bind(this)
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  selectMenu(){
    
  }
  logout() {
    this.props.history.replace('/login');
  }
  render() {
    return (
      <div>
        <Navbar color="faded" expand="md" className="header">
          <NavbarBrand tag={Link} to="/">

            <div className="header-logo">
              <div className="logo-peacock"></div>
              {/* <Logo fill="#f96e0a" /> */}
            </div>
          </NavbarBrand>

          <NavbarToggler className="icon-menu" onClick={this.toggle}>
            {!this.state.isOpen ? <Icon icon="fa-bars" /> : <Icon icon="fa-times" />}
          </NavbarToggler>

          <Collapse isOpen={this.state.isOpen} navbar>
            <MenuList onSelect={this.selectMenu} selected={this.state.selected}/>
          </Collapse>

        </Navbar>
      </div>
    );
  }
}
export const MenuList = (props) => {
  return (
    <Nav className="ml-auto" navbar>
      <NavItem>
        <NavLink tag={Link} to="/" className="nav-hover">
          <Icon icon="fa-home" /> Home</NavLink>
      </NavItem>
      <NavItem>
        <NavLink tag={Link} to="/gallery" className={classNames("nav-hover")}><Icon icon="fa-images" /> Gallery</NavLink>
      </NavItem>
      <NavItem>
        <NavLink tag={Link} to="/cart" className="nav-hover"><Icon icon="fa-cart-arrow-down" /> Cart <CartCount itemCount="5" /> </NavLink>
      </NavItem>
      <NavItem>
        <NavLink tag={Link} to="/aboutus" className="nav-hover"><Icon icon="fa-info-circle" /> About Us</NavLink>
      </NavItem>
      <Login onLogOut={this.logout} />
    </Nav>
  )
}



const mapStateToProps1 = state => {
  return { loggedIn: state.loggedIn }
}
function logout() {
  localStorage.removeItem('isLoggged');
  store.dispatch(SetLoggedIn(false))
}
const Login = connect(mapStateToProps1)((props) => (
  <NavItem>
    {
      !props.loggedIn
        ? <NavLink tag={Link} to="/login" className="nav-hover"><Icon icon="fa-sign-in-alt" /> Login</NavLink>
        : <NavLink tag={Link} to="/login" className="nav-hover" onClick={logout}><Icon icon="fa-sign-in-alt" /> Logout</NavLink>
    }
  </NavItem>
))


//CART LOGIC
const mapStateToProps2 = state => {
  return { itemCount: state.cart.length }
}
const CartCount1 = (props) => (
  <span>
    {
      props.itemCount > 0 && <Badge color="success">{props.itemCount}</Badge>
    }
  </span>
)


const CartCount = connect(mapStateToProps2)(CartCount1)




// WEBPACK FOOTER //
// ./src/header.jsx